import { z } from 'zod';

// Stati del job di elaborazione
export type StatoElaborazione = 'IN_CORSO' | 'COMPLETATO' | 'ERRORE' | 'ERRORE_IMPORT' | 'IMPORTATO';

export const StatoElaborazioneSchema = z.enum(['IN_CORSO', 'COMPLETATO', 'ERRORE', 'ERRORE_IMPORT', 'IMPORTATO']);

export const CaricamentoCassaSchema = z.object({
  id: z.number(),
  codice_fenice: z.number().refine(v => v === 280 || v === 281),
  cassa: z.enum(['CE', 'EC']),
  anno: z.number(),
  mese: z.number(),
  stato: StatoElaborazioneSchema.default('IN_CORSO'),
  nome_tabella: z.string().nullable(),
  stats_json: z.string().nullable(),       // JSON.stringify di ElaboraCassaResult.stats
  warnings_json: z.string().nullable(),    // JSON.stringify di warnings[]
  errore: z.string().nullable(),           // messaggio errore se stato=ERRORE
  import_json: z.string().nullable(),      // JSON.stringify di ImportResult
  file_path: z.string().nullable(),        // path CSV generato
  importato_at: z.string().nullable(),     // DATETIME import completato
  created_at: z.string().optional(),
});

export type CaricamentoCassa = z.infer<typeof CaricamentoCassaSchema>;

export type CaricamentoCassaInsert = {
  codice_fenice: 280 | 281;
  cassa: 'CE' | 'EC';
  anno: number;
  mese: number;
  stato?: StatoElaborazione;
  nome_tabella?: string | null;
  stats_json?: string | null;
  warnings_json?: string | null;
  errore?: string | null;
  import_json?: string | null;
  file_path?: string | null;
  importato_at?: string | null;
};

export const CODICE_FENICE = {
  CE: 280,
  EC: 281,
} as const;
